import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Truncate from 'react-truncate';
import Tooltip from '@material-ui/core/Tooltip';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// STYLES
import { SeasonsInfoStyled } from './styles';

function formatCount(value) {
  if (value[0] === value[1]) {
    return value[0];
  }

  return value[1] - 1 === value[0] ? value.join(', ') : value.join('-');
}

function formatTitle(count) {
  return formatCount(count);
}

function getSeasonsData(data) {
  const firstSeasonNumber = data[0].season_number;

  const { titles, hasPartial } = data.reduce(
    (acc, el, idx, arr) => {
      const seasonNumber = el.season_number;
      const isFullSeason = el.full_season;
      const nextItem = arr[idx + 1];

      if (!acc.hasPartial && !isFullSeason) {
        acc.hasPartial = true;
      }

      if (
        !nextItem ||
        nextItem.full_season !== isFullSeason ||
        nextItem.season_number !== seasonNumber + 1
      ) {
        acc.titles.push(formatTitle(acc.count, isFullSeason));

        if (!nextItem) {
          return acc;
        }

        const newSeason = nextItem.season_number;

        acc.count = [newSeason, newSeason];

        return acc;
      }

      acc.count[1] += 1;

      return acc;
    },
    {
      titles: [],
      count: [firstSeasonNumber, firstSeasonNumber],
      hasPartial: false,
    },
  );

  return {
    title: titles.join(', '),
    hasPartial,
  };
}

function SeasonsInfo({ data }) {
  const [isTruncated, setTruncated] = useState(false);
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('md'));
  const [t] = useTranslation();

  if (!data?.seasons?.length) {
    return null;
  }

  const { full_episodes, seasons } = data;

  const seasonData = {
    title: '',
    hasPartial: false,
  };

  if (full_episodes) {
    seasonData.title = t('showDetails.fullSeries');
  } else if (seasons.length === 1) {
    seasonData.title = `${t('common.season')} ${seasons[0].season_number}`;
  } else {
    const { title, hasPartial } = getSeasonsData(seasons);

    seasonData.title = `${t('common.seasons')} ${title}`;
    seasonData.hasPartial = hasPartial;
  }

  const title = (
    <p className="p4 seasons-info__title">
      {!isMobile ? (
        <Truncate
          lines={1}
          onTruncate={isTruncatedLine => {
            if (isTruncatedLine !== isTruncated) {
              setTruncated(isTruncatedLine);
            }
          }}
        >
          {seasonData.title}
        </Truncate>
      ) : (
        seasonData.title
      )}
    </p>
  );

  return (
    <SeasonsInfoStyled className="seasons-info">
      {isTruncated ? (
        <Tooltip title={<p className="p4">{seasonData.title}</p>} placement="top">
          {title}
        </Tooltip>
      ) : (
        title
      )}
    </SeasonsInfoStyled>
  );
}

SeasonsInfo.propTypes = {
  data: PropTypes.object,
};

export default React.memo(SeasonsInfo);
